import React, {Fragment} from 'react';
import { Link } from "react-router-dom";

import Menu from '../../components/Nav/Menu'

import { FiCoffee } from "react-icons/fi";
import {FaAngleLeft, FaAngleRight} from 'react-icons/fa';

import navigation from '../../config/_aside'


const Aside = ({toggled, isCollapsed, isAdmin}) => {    
    
    const btnToggled = () => {
        isCollapsed(!toggled)       
    }

    return ( 
        <>
            <ul className={`navbar-nav bg-gradient-primary sidebar sidebar-dark accordion ${toggled ? 'toggled': ''}`} id="accordionSidebar">

            <Link className="sidebar-brand d-flex align-items-center justify-content-center"  to={"/"}>
                <div className="sidebar-brand-icon rotate-n-15">
                    <i className="fas fa-laugh-wink"><FiCoffee /></i>
                </div>
                <div className="sidebar-brand-text mx-3">Idesoft<sup></sup></div>
            </Link>  
            
            {navigation.map( item => {
                return (
                    <>
                        {item.rol_admin && isAdmin ?
                            <Menu key={item.section} item={item} toggled={toggled}/>:
                            null
                        }
                        {!item.rol_admin ?
                            <Menu key={item.section} item={item} toggled={toggled}/>:
                            null
                        }
                    </>
                )
            })}

            <hr className="sidebar-divider d-none d-md-block" />

            <div className="text-center d-none d-md-inline">
                <button className="rounded-circle border-0" id="sidebarToggle" onClick={() => btnToggled()}>
                    {!toggled ?
                        <FaAngleLeft className="svg-icon" /> :
                        <FaAngleRight className="svg-icon" />
                    }
                    </button>
            </div>

        </ul>
        </>
     );
}
 
export default Aside;
